import { type DisplayMessage, isEnrichedToolMessage, isFileEditCompleteToolMessage } from '../../../hooks/messageTypes';
import { getSmartResizeFollowUpScope } from './getSmartResizeFollowUpScope';

/** Scope of the last smart-resize run, but only while it is the conversation's tail (null once a user message or another tool result follows it). */
export const selectTailSmartResizeFollowUpScope = (
  messages: DisplayMessage[],
): ReturnType<typeof getSmartResizeFollowUpScope> => {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i];

    // Assistant messages after the result are the same run's tool-call carriers or closing reply, so they don't count
    // as the conversation moving on: hidden programmatic runs carry no agent text (the backend drops it) and visible
    // sends start with a user message, so assistant text after a result is that run's own reply.
    if (message.role === 'assistant') {
      continue;
    }

    if (isEnrichedToolMessage(message) && isFileEditCompleteToolMessage(message) && message.status === 'completed') {
      return getSmartResizeFollowUpScope(message.parsedContent);
    }

    return null;
  }

  return null;
};
